import { useQuery } from '@tanstack/react-query'
import { logError } from '@node-space/utils'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getLegalAgreements } from 'services/AgreementsService'
import { LegalAgreementStatusType } from 'pages/LegalAgreements/types'

export const useLegalAgreementsQuery = (
  statusParams?: LegalAgreementStatusType[],
  isEnabled = true
) => {
  return useQuery(
    reactQueryKeys.legalAgreements(statusParams),
    () => getLegalAgreements(statusParams),
    {
      refetchOnWindowFocus: false,
      enabled: isEnabled,
      onError: (error: unknown) => {
        logError('Error: useLegalAgreementsQuery', error)
      },
    }
  )
}
